import axios from 'axios'

function fetchAllTools() {
  return axios.get(`/api/tools.json`)
    .then(res => res.data)
}

function fetchToolBySlug(slug) {
  return axios.get(`/api/tools/${slug}.json`)
    .then(res => res.data)
}

function fetchToolReviewsBySlug(slug) {
  return axios.get(`/api/tools/${slug}/reviews.json`)
    .then(res => res.data)
}

function createToolReview(toolId, reviewData) {
  const review = {
    tool_id: toolId,
    rating: reviewData.isUpvote ? 'upvote' : 'downvote',
    name: reviewData.name,
    review_text: reviewData.review
  }

  return axios.post(`/api/reviews.json`, { review })
    .then(res => res.data)
}

export default {
  fetchToolBySlug,
  fetchAllTools,
  fetchToolReviewsBySlug,
  createToolReview
}
